module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "lo"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f000i-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('p', {
    staticClass: "break"
  })]), _c('p', {
    staticClass: "ach"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_vm._v("Also by Julia Gregson")])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("East of the Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "break"
  })]), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "title"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("Band of Angels")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "im"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0iii-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "au"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULIA")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGSON")])]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_vm._v("A T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUCHSTONE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _c('br'), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLISHED BY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMON")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHUSTER")]), _c('br'), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDON")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORONTO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YDNEY")])]), _vm._v(" "), _c('p', {
    staticClass: "break"
  })]), _c('p', {
    staticClass: "crlo"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "id": "copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "cr"
  }, [_vm._v("Touchstone")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("A Division of Simon & Schuster, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("1230 Avenue of the Americas")])]), _c('p', {
    staticClass: "cr"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("New York, NY 10020"), _c('br'), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.SimonandSchuster.com",
      "target": "_blank"
    }
  }, [_vm._v("www.SimonandSchuster.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("This book is a work of fiction. Names, characters, places, and incidents either are"), _c('br'), _vm._v("products of the author’s imagination or are used fictitiously. Any resemblance to"), _c('br'), _vm._v("actual events or locales or persons, living or dead, is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("Copyright © 2004 by Julia Gregson")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("Originally published in Great Britain in 2004 by Orion, an Hachette Livre"), _c('br'), _vm._v("UK company")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("All rights reserved, including the right to reproduce this book or portions thereof"), _c('br'), _vm._v("in any form whatsoever. For information address Touchstone Subsidiary Rights"), _c('br'), _vm._v("Department, 1230 Avenue of the Americas, New York, NY 10020.")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("First Touchstone trade paperback edition May 2010")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("TOUCHSTONE and colophon are registered trademarks of Simon & Schuster, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("For information about special discounts for bulk purchases,"), _c('br'), _vm._v("please contact Simon & Schuster Special Sales at 1-866-506-1949 or"), _c('br'), _vm._v("business@simonandschuster.com.")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("The Simon & Schuster Speakers Bureau can bring authors to your live event."), _c('br'), _vm._v("For more information or to book an event contact the Simon & Schuster Speakers Bureau at 1-866-248-3049 or visit our website at "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.simonspeakers.com",
      "target": "_blank"
    }
  }, [_vm._v("www.simonspeakers.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("Gregson Julia.")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("Band of angels : a novel / Julia Gregson.")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("1. Young Women—England—Fiction. 2. Nurses—Fiction. 3. British—")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("Ukraine—Crimea—Fiction. 4. Crimean War, 1853–1856—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("PR6107.R44494B36 2010")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("823’.92—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("2009042198")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("ISBN 978-1-4391-0113-1 (pbk)")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("ISBN 978-1-4391-1778-1 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "dedi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('em', [_vm._v("For Vicki, Richard, Caroline, and Poppy")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3488cb43","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/001.vue
// module id = 63
// module chunks = 0